/*
 * Ryan O'Dowd
 * 2023-01-21
 * © Copyright 2023 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import React from 'react';
import Text from '@components/common/Text';
import Tooltip from '@components/common/Tooltip';
import {
  View,
} from 'react-native';
import {
  format as dateFnsFormat,
} from 'date-fns';
import getStyles from './styles';
import globals from '@utils/globals';
import hooks from '@hooks';

const MESSAGE_TIME_FORMAT = "MMM d, yyyy '@' h:mmaaaaa'm'";

const Note = (props: NoteProps) => {
  const styles = hooks.useStyles(getStyles);
  const oakUser = hooks.useTypedSelector((state) => state.oakUser);

  const isMyMessage = props.user_id === oakUser.id;
  const isBotMessage = props.user_id === globals.wrinklyBotId;

  return (
    <View
      style={[
        styles.container,
        isMyMessage && styles.myMessageContainer,
        isBotMessage && styles.botMessageContainer,
      ]}
    >
      <View
        style={[
          styles.containerInner,
          isMyMessage && styles.myMessageContainerInner,
          isBotMessage && styles.botMessageContainerInner,
        ]}
      >
        <Tooltip title={dateFnsFormat(new Date(props.created_at), MESSAGE_TIME_FORMAT)}>
          <React.Fragment>
            <View style={styles.noteBody}>{props.notes.split('\n').map((line, index) => <Text key={index} style={[styles.line, isBotMessage && styles.botMessageText]}>{line}</Text>)}</View>
            {!isBotMessage &&
              <View style={styles.rightWrapper}>
                <Text style={[styles.user, isMyMessage && styles.myMessageUsername]}>
                  {props.user?.username}
                </Text>
              </View>
            }
          </React.Fragment>
        </Tooltip>
      </View>
    </View>
  );
};

class NoteProps {
  id: number;
  created_at: any;
  user_id: number;
  i18n_id: number;

  notes?: string;
  parent_note_id?: number;
  upvoted?: number;
  user?: any;
};

export default Note;
